import {observable, action} from 'mobx';
import base from '../../tool/base';
import {message} from 'antd';
import { Base64 } from 'js-base64';
import util from '../../util/index';

const catchApiError = util.catchApiError;
export class InitStore {
  routing = null;

  constructor(routing) {
    this.routing = routing;
  }

  @observable me = {};
  @observable visible = false;
  @observable loadingPage = false;
  @observable ecloginStatus = 1; // 0 未登录 1 登录输入 2 已登录
  @observable ecloginKey = '';
  @observable rememberId = false;
  @observable rememberPass = false;
  @observable loginId = '';
  @observable loginPass = '';
  @observable loading = false;
  @observable captcha = '';
  @observable captchaImg = '';

  @action
  setState = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key];
    });
    return this;
  }

  @action
  setType(type, typeName) {
  }

  @action
  exit = () => {
    localStorage.removeItem('me');
    this.me = {};
  }
  
  @action
  doRemember = () => {
    const rememberId = this.rememberId;
    const rememberPass = this.rememberPass;
    const loginId = this.loginId;
    const loginPass = this.loginPass;
    localStorage.rememberId = rememberId;
    localStorage.rememberPass = rememberPass;
    if (rememberId) localStorage.loginId = loginId;
    else localStorage.removeItem('loginId');
    if (rememberPass) localStorage.loginPass = loginPass;
    else localStorage.removeItem('loginPass');
  }

  initMe = data => {
    if (data) {
      localStorage.me = JSON.stringify(data);
    }
    this.me = (data ? {
      token: data.token.access_token,
      role: data.role,
      data: data
    } : {data: {com: ""}})
  }

  reGetMe(params) {
    this.loadingPage = true;
    base.callApi('/newlogin', 'GET', params, 'json', 'text').then((data) => {
      this.initMe(data.params);
      const {hash} = window.location
      hash && hash.indexOf('key=') > 0
        ? this.routing.push('/')
        : (window.location.href = '/web/');
      this.loadingPage = false;
    });
  }

  doLogin = params => {
    this.loading = true;
    base.callApi('/v2/login', 'POST', params, 'json', 'text').then((data) => {
      if (data.status === 'true') {
        this.initMe(data);
        this.routing && this.routing.push('/');
        this.doRemember();
      } else {
        message.error(data.msg || '登录失败，请重试！');
      }
      if (!data.checkCaptcha) this.generateCaptcha({ mobile: this.loginId });
      this.loading = false;
    });
  }

  doEcLogin = params => {
    const ecloginkey = Base64.encode(JSON.stringify(params));
    if (window.navigator.appVersion.indexOf('MSIE 9.0') > 0) {
      window.open(`https://e-cloudstore.com/#/?eclogin=1&ecloginkey=${ecloginkey}`);
    } else {
      this.loading = true;
      base.callApi('/v2/login', 'POST', params, 'json', 'text').then((data) => {
        if (data.status === 'true') {
          this.initMe(data);
          this.ecloginKey = ecloginkey;
          this.ecloginStatus = 2;
          window.open(`https://e-cloudstore.com/#/?eclogin=1&ecloginkey=${ecloginkey}`);
          this.doRemember();
        } else {
          message.error(data.msg || '登录失败，请重试！');
        }
        if (!data.checkCaptcha) this.generateCaptcha({ mobile: this.loginId });
        this.loading = false;
      });
    }
  }

  doRegister = params => {
    return new Promise(res => {
      base.callApi('/v2/sys/join', 'POST', params, 'json', 'text').then((data) => {
        if (data.status) {
          this.visible = true;
        }
        res(data);
      });
    })
  }

  checkToken = (params = {}) => {
    if (!localStorage.me) {
     // message.info("对不起，此功能暂无权限！请登录后使用！");
    } else {
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : {role: ""};
      base.callApi('/v3/checkToken?access_token='+me.token.access_token, 'GET', params, 'json', 'text').then((data) => {
        if(!data) {
          localStorage.removeItem('me');
          this.me = {};
        }
      });
    }
  }

  @action
  generateCaptcha = (params = {}) => {
    const param = {
      mobile: this.loginId,
      ...params,
    };
    if (param.mobile && param.mobile !== '') {
      return new Promise(resolve => {
        base.callApi('/v5/support/generateCaptcha', 'GET', param, 'json', 'text').then((result) => catchApiError(result, this.routing)).then((data) => {
          if (data.status) {
            this.captchaImg = data.captchaImage;
          }
          resolve(data);
        });
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/stores/init/InitStore.js